import fluidGridColumns from '../../../theme/fluidGridColumns';
import { GridItemProps } from '../../Grid';

export const marketingPromoBadgeGridProps: GridItemProps = {
  desktop: 4,
  tabletLandscape: 4,
  tabletPortrait: 3,
  mobile: fluidGridColumns.mobile,
};

export const marketingPromoCopyGridProps: GridItemProps = {
  desktop: 8,
  tabletLandscape: 8,
  tabletPortrait: 5,
  mobile: fluidGridColumns.mobile,
};

export const finePrintWidthInColumns: GridItemProps = {
  desktop: 7,
  tabletLandscape: 7,
  tabletPortrait: 5,
  mobile: fluidGridColumns.mobile,
};
